import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    drawerPaper: {
      backgroundColor: theme.palette.common.backgroundMuted,
    },
    customTooltip: {
      backgroundColor: theme.palette.common.backgroundDark,
      padding: 10,
      fontSize: 12,
      marginTop: '-25px',
      marginLeft: 40,
    },
    drawerHeader: {
      padding: '0 0 0 30px',
      position: 'relative',
    },
    envName: {
      position: 'absolute',
      top: 30,
      left: 16,
    },
    navigationMenu: {
      width: '40vw',
      overflowX: 'hidden',
      [theme.breakpoints.down('md')]: {
        width: '50vw',
      },
      [theme.breakpoints.down('xs')]: {
        width: '70vw',
      },
      '& .navigationListItem': {
        backgroundColor: theme.palette.common.backgroundMuted,
        margin: 0,
        fontWeight: 500,
        fontSize: 16,
        paddingBottom: 9,
        borderBottom: `1px solid ${theme.palette.common.backgroundDark}`,
        width: '70%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
        '&.disabled': {
          cursor: 'not-allowed',
          opacity: 0.32,
        },
        '&:hover': {
          paddingBottom: 8,
          borderBottom: `2px solid ${theme.palette.common.coral}`,
        },
        '& span': {
          fontWeight: 500,
        },
      },

      '& .active': {
        backgroundColor: theme.palette.common.coral,
        color: theme.palette.common.backgroundDark,
        '&:hover': {
          backgroundColor: theme.palette.common.coral,
          color: theme.palette.common.backgroundDark,
        },
      },
    },
    navigationListItemSignOut: {
      backgroundColor: theme.palette.common.backgroundMuted,
      margin: 0,
      fontSize: 16,
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    navigationAccordion: {
      margin: '0',
      minHeight: 0,
      paddingBottom: 1,
      backgroundColor: theme.palette.common.backgroundMuted,
      borderBottom: `1px solid ${theme.palette.common.backgroundDark}`,
      boxShadow: 'none',
      width: '70%',
      '&:hover': {
        paddingBottom: 0,
        borderBottom: `2px solid ${theme.palette.common.coral}`,
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      '& .text': {
        fontWeight: 500,
      },
      '&.Mui-expanded': {
        margin: '0',
      },
    },
    navigationAccordionItem: {
      '& .MuiAccordionSummary-expandIcon': {
        position: 'relative',
        '&.Mui-expanded': {
          position: 'absolute',
          top: -8,
          right: 16,
          transform: 'none',
          transition: 'none',
          marginBottom: '0',
        },
      },
    },
    navigationDropDownListItem: {
      backgroundColor: theme.palette.common.backgroundMuted,
      margin: 0,
      padding: '4px 0',
      fontSize: 16,
      width: '70%',
      alignItems: 'flex-start',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    navigationDropDownListItemText: {
      textTransform: 'uppercase',

      '& span': {
        fontFamily: theme.typography.fontFamily,
        // @ts-expect-error — custom letterSpacing extension on theme typography
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        letterSpacing: theme.typography.letterSpacing,
        fontSize: 15,
        fontWeight: 500,
      },
    },
    navigationDropDownListItemIcon: {
      margin: '7px 10px 0 0',
      width: '42',
    },
    signOutBtn: {
      width: 250,
      [theme.breakpoints.down('md')]: {
        width: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  });

export default styles;
